import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

import '../fichierCss/Affichage.css'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

interface ContactProps {
  image?: string;
  titre?: React.ReactNode;
  contenu?: React.ReactNode;
}

const Contact = ({ image, titre, contenu }: ContactProps) => {
    
    const classes = useStyles();

    return (
        <div className={classes.root}>
          <Grid container spacing={3}>       
            <Grid item xs={7}>
                <Paper className={classes.paper}>
                    <div id="image">           
                        <img src={image}
                            style={{
                                height: 500,
                                width: 740,
                                alignItems: "left",
                                padding:"5px",
                                }}
                        
                        />
                    </div> 
                </Paper>
            </Grid>
            <Grid item xs={5}>
              <Paper className={classes.paper}>
                  {titre}
                  Lors de l’inscription, une équipe de deux sages-femmes vous est attribuée, afin de vous garantir une disponibilité constante 24h sur 24 et 7 jours sur 7. Vous pouvez en tout temps les rejoindre. La sage-femme principale assure la grande partie de votre suivi. Vous rencontrerez sa coéquipière afin d’établir un lien de confiance avec cette dernière. Les sages-femmes reconnaissent l’importance de la continuité des soins pour un suivi de qualité.
                  Lors de l’inscription, une équipe de deux sages-femmes vous est attribuée, afin de vous garantir une disponibilité constante 24h sur 24 et 7 jours sur 7. Vous pouvez en tout temps les rejoindre. La sage-femme principale assure la grande partie de votre suivi. Vous rencontrerez sa coéquipière afin d’établir un lien de confiance avec cette dernière. Les sages-femmes reconnaissent l’importance de la continuité des soins pour un suivi de qualité.
                  Lors de l’inscription, une équipe de deux sages-femmes vous est attribuée, afin de vous garantir une disponibilité constante 24h sur 24 et 7 jours sur 7. Vous pouvez en tout temps les rejoindre. La sage-femme principale assure la grande partie de votre suivi. Vous rencontrerez sa coéquipière afin d’établir un lien de confiance avec cette dernière. Les sages-femmes reconnaissent l’importance de la continuité des soins pour un suivi de qualité.
                  </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                {contenu}
            </Paper>
            </Grid>
          
          </Grid>
        </div>
      );
} 
export default Contact